export default __webpack_public_path__ + "static/media/043-fire.4a639991.png";